/* eslint-disable max-lines-per-function */
/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-key */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import { Fragment, useEffect } from 'react';
import { Icon } from '@prc/icons';
import UserContext from '../context/context';
import {
	useContext,
	useState,
	useReducer,
	useCallback,
} from '@wordpress/element';

const Table = () => {
	const context = useContext(UserContext);
	const { types, selectedChild, selectedView, selectedParent } = context;
	console.log('selectedChild', selectedChild);

	const { name, answers, question, data } = selectedChild;

	const [slug, setSlug] = useState([]);

	const addSlug = (slugText) => {
		if (slug.includes(slugText)) {
			setSlug(slug.filter((item) => item !== slugText));
		} else {
			setSlug([...slug, slugText]);
		}
	};

	function displayTwoBars(d, i) {
		return (
			<tbody>
				{types.map((d, i) => (
					<Fragment>
						<tr>
							<td
								className={`type touch ${d.slug} ${
									i == types.length - 1 && 'disable'
								} `}
								data-selector={`#${d.slug}`}
								onClick={() => addSlug(d.slug)}
							>
								<span className="type-label-row">
									<svg
										width="8"
										height="44"
										viewBox="0 0 8 44"
										xmlns="http://www.w3.org/2000/svg"
										aria-hidden="true"
									>
										<rect
											width="8"
											height="44"
											fill={d.color}
										/>
									</svg>
									<span className="type-label-text">
										{d.name}
									</span>
									{i < types.length - 1 && (
										<span
											className="type-expand-icon"
											aria-hidden="true"
										>
											{slug.includes(d.slug) ? (
												<svg
													width="19"
													height="15"
													viewBox="0 0 19 15"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fillRule="evenodd"
														clipRule="evenodd"
														d="M14 7.5C14 11.0899 11.0899 14 7.5 14C3.91015 14 1 11.0899 1 7.5C1 3.91015 3.91015 1 7.5 1C11.0899 1 14 3.91015 14 7.5ZM15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5ZM3.97058 7C3.69444 7 3.47058 7.22386 3.47058 7.5C3.47058 7.77614 3.69444 8 3.97058 8H11.0294C11.3055 8 11.5294 7.77614 11.5294 7.5C11.5294 7.22386 11.3055 7 11.0294 7H3.97058Z"
														fill="#818181"
													/>
												</svg>
											) : (
												<svg
													width="19"
													height="15"
													viewBox="0 0 15 15"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fillRule="evenodd"
														clipRule="evenodd"
														d="M14 7.5C14 11.0899 11.0899 14 7.5 14C3.91015 14 1 11.0899 1 7.5C1 3.91015 3.91015 1 7.5 1C11.0899 1 14 3.91015 14 7.5ZM15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5ZM7.53402 3.52941C7.81017 3.52941 8.03402 3.75327 8.03402 4.02941V7H11.0294C11.3056 7 11.5294 7.22386 11.5294 7.5C11.5294 7.77614 11.3056 8 11.0294 8H8.03402V10.9706C8.03402 11.2467 7.81017 11.4706 7.53402 11.4706C7.25788 11.4706 7.03402 11.2467 7.03402 10.9706V8H3.97059C3.69445 8 3.47059 7.77614 3.47059 7.5C3.47059 7.22386 3.69445 7 3.97059 7H7.03402V4.02941C7.03402 3.75327 7.25788 3.52941 7.53402 3.52941Z"
														fill="#818181"
													/>
												</svg>
											)}
										</span>
									)}
								</span>
							</td>

							<td
								className="value left"
								style={{ '--bar-width': `${data[i][0]}%` }}
							>
								<div
									style={{
										width: `${data[i][0]}% `,
										textAlign: 'center',
									}}
									className="animate"
								>
									{1 > data[i][0]
										? ''
										: 0 == i
											? `${data[i][0]}% `
											: `${data[i][0]} `}
								</div>
							</td>
							<td
								className="value right"
								style={{ '--bar-width': `${data[i][1]}%` }}
							>
								<div
									style={{
										width: `${data[i][1]}% `,
										textAlign: 'center',
									}}
									className="animate"
								>
									{1 > data[i][1]
										? ''
										: 0 == i
											? `${data[i][1]}% `
											: `${data[i][1]} `}{' '}
								</div>
							</td>
						</tr>

						<tr>
							<td
								colspan="3"
								id={`${d.slug} -text`}
								className="type-description"
								style={{
									display: slug.includes(d.slug)
										? 'table-cell'
										: 'none',
								}}
							>
								{d.text}{' '}
								<a
									href={d.link}
									target="_blank"
									className="readMore"
								>
									{' '}
									Learn more about {d.name}{' '}
									<span aria-hidden="true">
										<Icon icon="arrow-up-right" />
									</span>
								</a>
							</td>
						</tr>
						{i < types.length - 1 && <hr />}
					</Fragment>
				))}
			</tbody>
		);
	}

	function displayBars(d, i) {
		return (
			<tbody>
				{types.map((d, i) => (
					<Fragment>
						<tr>
							<td
								className={`type touch ${d.slug} ${
									i == types.length - 1 && 'disable'
								} `}
								data-selector={`#${d.slug}`}
								onClick={() => addSlug(d.slug)}
							>
								<span className="type-label-row">
									<svg
										width="8"
										height="44"
										viewBox="0 0 8 44"
										xmlns="http://www.w3.org/2000/svg"
										aria-hidden="true"
									>
										<rect
											width="8"
											height="44"
											fill={d.color}
										/>
									</svg>
									<span className="type-label-text">
										{d.name}
									</span>
									{i < types.length - 1 && (
										<span
											className="type-expand-icon"
											aria-hidden="true"
										>
											{slug.includes(d.slug) ? (
												<svg
													width="19"
													height="15"
													viewBox="0 0 19 15"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fillRule="evenodd"
														clipRule="evenodd"
														d="M14 7.5C14 11.0899 11.0899 14 7.5 14C3.91015 14 1 11.0899 1 7.5C1 3.91015 3.91015 1 7.5 1C11.0899 1 14 3.91015 14 7.5ZM15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5ZM3.97058 7C3.69444 7 3.47058 7.22386 3.47058 7.5C3.47058 7.77614 3.69444 8 3.97058 8H11.0294C11.3055 8 11.5294 7.77614 11.5294 7.5C11.5294 7.22386 11.3055 7 11.0294 7H3.97058Z"
														fill="#818181"
													/>
												</svg>
											) : (
												<svg
													width="15"
													height="15"
													viewBox="0 0 15 15"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fillRule="evenodd"
														clipRule="evenodd"
														d="M14 7.5C14 11.0899 11.0899 14 7.5 14C3.91015 14 1 11.0899 1 7.5C1 3.91015 3.91015 1 7.5 1C11.0899 1 14 3.91015 14 7.5ZM15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5ZM7.53402 3.52941C7.81017 3.52941 8.03402 3.75327 8.03402 4.02941V7H11.0294C11.3056 7 11.5294 7.22386 11.5294 7.5C11.5294 7.77614 11.3056 8 11.0294 8H8.03402V10.9706C8.03402 11.2467 7.81017 11.4706 7.53402 11.4706C7.25788 11.4706 7.03402 11.2467 7.03402 10.9706V8H3.97059C3.69445 8 3.47059 7.77614 3.47059 7.5C3.47059 7.22386 3.69445 7 3.97059 7H7.03402V4.02941C7.03402 3.75327 7.25788 3.52941 7.53402 3.52941Z"
														fill="#818181"
													/>
												</svg>
											)}
										</span>
									)}
								</span>
							</td>
							<td
								className="value center"
								style={{ display: 'flex' }}
							>
								{answers.map((e, j) => (
									<div
										className={`${
											answers.length >= 6
												? 'many-answers'
												: ''
										} ${
											selectedChild.slug === '2024-vote'
												? 'candidates'
												: ''
										}`.trim()}
										style={{ width: `${data[i][j]}%` }}
									>
										{1 > data[i][j]
											? ''
											: 0 == i
												? `${Math.round(data[i][j])}% `
												: `${Math.round(data[i][j])} `}
									</div>
								))}
							</td>
						</tr>

						<tr>
							<td
								colspan="2"
								id={`${d.slug} -text`}
								className="type-description"
								style={{
									display: slug.includes(d.slug)
										? 'table-cell'
										: 'none',
								}}
							>
								{d.text} <br />
								<a
									href={d.link}
									target="_blank"
									className="readMore"
								>
									{' '}
									Learn more about {d.name}{' '}
									<span aria-hidden="true">
										<Icon icon="arrow-up-right" />
									</span>
								</a>
							</td>
						</tr>

						{i < types.length - 1 && <hr />}
					</Fragment>
				))}
			</tbody>
		);
	}

	return (
		<div key={name}>
			{selectedView === 'key topics' ? (
				<>
					<div className="typology-feature-update-breadcrumbs">
						TOPICS | {selectedParent.toUpperCase()}
					</div>
				</>
			) : (
				<>
					<div className="typology-feature-update-breadcrumbs">
						DEMOGRAPHICS
					</div>
				</>
			)}
			<h2> {name} </h2>
			<p className="percent-saying">{question}</p>
			<table>
				<thead>
					{2 < answers.length ? (
						<tr>
							<th className="center" colspan="2">
								{answers.map((answer, i) => (
									<div>
										<span
											class={`legend legend-${i}${
												answers.length >= 6
													? ` many-answers-legend-${i}`
													: ''
											}${
												selectedChild.slug ===
												'2024-vote'
													? ' candidates'
													: ''
											}`}
										></span>
										<span>{answer}</span>
									</div>
								))}
							</th>
						</tr>
					) : (
						<tr>
							<th className="center" colspan="3">
								<div>
									<span class="legend legend-0"></span>
									<span>{answers[0]}</span>
								</div>
								<div>
									<span class="legend legend-1"></span>
									<span>{answers[1]}</span>
								</div>
							</th>
						</tr>
					)}
				</thead>

				{3 <= answers.length ? displayBars() : displayTwoBars()}
			</table>
		</div>
	);
};

export default Table;
